// Must match the key read in react/Services/cockpitStatus.ts
const STORAGE_KEY = 'cockpitSupportContexts';
const MAX_CONTEXTS = 5;

const storeContext = (id: string, data: object): boolean => {
    try {
        let contexts: { id: string, data: object }[] = [];
        try {
            const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]');
            if (Array.isArray(parsed)) {
                contexts = parsed;
            }
        } catch (e) {
            // corrupt entry, start over
        }
        contexts.push({id, data});
        localStorage.setItem(STORAGE_KEY, JSON.stringify(contexts.slice(-MAX_CONTEXTS)));
        return true;
    } catch (e) {
        // storage blocked or full
        return false;
    }
}

// This method is and should be globally available, as Packit is using it
export const getCockpitSupportUrl = (category: string | void) => {
    const element = <HTMLElement>document.querySelector('[data-support-button]');
    if (!element) {
        return null
    }
    const id = Math.random().toString(16).substring(2, 10);
    let data = {
        pageId: parseInt(element.getAttribute('data-page-id') ?? ''),
        category: category ?? null,
        packitStatus: {},
        timestamp: Math.round(Date.now() / 1000)
    }
    if (typeof (window as any).getFeedBackStatus === 'function') {
        const feedbackStatus = (window as any).getFeedBackStatus as Function;
        data.packitStatus = feedbackStatus();
    }
    // remove existing fragment identifier
    const hrefParts = (element.getAttribute('href') ?? '').split('#');
    if (!storeContext(id, data)) {
        return hrefParts[0];
    }
    return hrefParts[0] + '#?status=' + id;
}

(function () {
    let elements = <NodeListOf<HTMLElement>>document.querySelectorAll('[data-support-button],.cc-app-icon_link:has(.cc-app-icon_svg--help-dialog)');
    for (let i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', function () {
            this.setAttribute('href', getCockpitSupportUrl() ?? '#');
        });
    }
}());

// @ts-ignore
if (!globalThis.cockpitWebsite) {
    // @ts-ignore
    globalThis.cockpitWebsite = {}
}
// @ts-ignore
globalThis.cockpitWebsite.getCockpitSupportUrl = getCockpitSupportUrl
